import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import * as NotificationsActions from "../../../../store/notifications/notifications.actions";
import { Site } from 'src/app/model/site';
import { Observable, Subscription, filter } from 'rxjs';
import { selectCurrentSite } from 'src/app/store/site/site.selector';
import * as SceneryActions from 'src/app/store/scenery/scenery.actions';
import * as ScheduleActions from 'src/app/store/schedule/schedule.actions';
import * as CalendarActions from 'src/app/store/calendar/calendar.actions';
import { selectStepAdded, selectStepEdited } from 'src/app/store/scenery/scenery.selector';
import { selectIsDraftMode } from 'src/app/store/user/user.selector';
import { selectTopbarTitle } from 'src/app/store/notifications/notifications.selector';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	selector: 'app-scenarios',
	templateUrl: './scenarios.component.html',
	providers: [],
})

export class ScenariosComponent implements OnInit, OnDestroy {
	site$: Observable<Site | undefined>;
	siteSub: Subscription | undefined;
	stepAdded$: Observable<boolean | undefined>;
	stepAddedSub: Subscription | undefined;
	stepEdited$: Observable<boolean | undefined>;
	stepEditedSub: Subscription | undefined;

	isDraftMode: boolean;
	isDraftMode$: Observable< boolean | undefined >;
	isDraftModeSub: Subscription;

	titleSel$: Observable<string>;
	titleSub: Subscription | undefined;
	titleId = '';

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
	) {
		this.initSelectors();
	}

	ngOnInit() {
		this.subscribeAll();
		this.store.dispatch(NotificationsActions.setTopbarTitleId({
				stringId: 'SCENARIOS'
		}));
		this.onResize();
	}

	ngOnDestroy(): void {
		this.siteSub?.unsubscribe();
		this.stepAddedSub?.unsubscribe();
		this.stepEditedSub?.unsubscribe();
		this.isDraftModeSub?.unsubscribe();
		this.titleSub?.unsubscribe();
	}

	initSelectors(): void{
		// Store selectors
		this.site$ = this.store.select(selectCurrentSite);
		this.stepAdded$ = this.store.select(selectStepAdded);
		this.stepEdited$ = this.store.select(selectStepEdited);
		this.isDraftMode$ = this.store.select(selectIsDraftMode);
		this.titleSel$ = this.store.select(selectTopbarTitle);
	}

	subscribeAll(): void {
		this.siteSub = this.site$?.pipe(filter(site => !!site))
		.subscribe(site => {
				this.store.dispatch(SceneryActions.getSceneries({ siteId: site.Id }));
				this.store.dispatch(SceneryActions.getSteps({}));
				this.store.dispatch(SceneryActions.getActions({}));
				this.store.dispatch(ScheduleActions.getSchedules({ siteId: site.Id }));
				this.store.dispatch(CalendarActions.getCalendars({ siteId: site.Id }));
		});
		this.stepAddedSub = this.stepAdded$?.pipe(filter(add => !!add))
			.subscribe(() => { 
				this.store.dispatch(SceneryActions.getSteps({}));
				this.store.dispatch(SceneryActions.getActions({}));
			});
        this.stepEditedSub = this.stepEdited$?.pipe(filter(edit => !!edit))
            .subscribe(() => { 
				this.store.dispatch(SceneryActions.getSteps({}));
				this.store.dispatch(SceneryActions.getActions({}));
			});
		this.store.dispatch(CalendarActions.getExceptions());
		this.isDraftModeSub = this.isDraftMode$.subscribe(
			(isDraftMode) => {
				this.isDraftMode = isDraftMode;
			}
		);
		this.titleSub = this.titleSel$.subscribe(
			(title: string) => {
				this.titleId = title;
			}
		);
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	layoutMarginResponsive() {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}
}
